import { TwilioService } from "../views/Chat/services";

export interface CreateConversationParams {
  uniqueName: string;
  customerName: string;
  orderHandlerName: string; 
}

export interface ChangeParticipantParams {
  conversationName: string;
  oldHandlerUserId: string;
  newHandlerUserId: string; 
  newOrderHandlerName?: string;
}

export async function changeParticipantInConversation({
  conversationName,
  oldHandlerUserId,
  newHandlerUserId,
  newOrderHandlerName,
}: ChangeParticipantParams): Promise<void> {
  try {
    const result = await TwilioService.changeParticipants(
      conversationName,
      oldHandlerUserId,
      newHandlerUserId,
      newOrderHandlerName
    );

    if (!result.ok) {
      throw new Error(result.note || "Failed to change participant");
    }
  } catch (error) {
    console.error("Changing Participant of Conversation failed", error);
    throw error;
  }
}
